<template>
  <div>
    <router-link
      :to="{
        name: 'app-flow',
        params: { appId: appId, flowId: identifier, mode: 'changelog', modeArg: changeId }
      }"
      >{{ $t('CHANGES_SINCE', { count: changesSince }) }}</router-link
    >, {{ relativeTime(change.ts || 0) }}
  </div>
</template>

<script>
// @flow
import Vue from 'vue'
import { Changelog } from 'services'
import moment from 'moment'

export default {
  name: 'version',
  props: ['appId', 'type', 'identifier', 'changeId', 'showAge', 'showChangesSince'],
  data() {
    return {
      changesSince: 0,
      change: {}
    }
  },

  computed: {
    currentLang() {
      return this.$locale.current()
    }
  },

  methods: {
    formatDate(ts) {
      return moment(new Date(0).setUTCSeconds(ts))
        .locale(this.currentLang)
        .format('DD/MM/YYYY HH:mm')
    },
    relativeTime(ts) {
      return moment(new Date(0).setUTCSeconds(ts))
        .locale(this.currentLang)
        .fromNow()
    }
  },

  mounted() {
    Changelog.getAllChanges(this.identifier, this.type).then(changes => {
      const idx = _.findIndex(changes, c => c.identifier === this.changeId)
      this.changesSince = idx
      if (idx >= 0) {
        this.change = changes[idx]
      }
    })
  }
}
</script>
